import type { FilterOptionType } from '../@types/forecastFilterTypes'

export const parseProductIdInput = (value: string, commitLastValue = false) => {
  if (!/^[\d,\s]*$/.test(value)) return null

  const values = value.split(/[\s,]+/).filter(Boolean)
  const hasTrailingDelimiter = /[\s,]$/.test(value)
  const shouldCommitLastValue = commitLastValue || hasTrailingDelimiter

  return {
    productIds: shouldCommitLastValue ? values : values.slice(0, -1),
    remainingValue: shouldCommitLastValue ? '' : values.at(-1) ?? '',
  }
}

export const addProductId = (productIds: string[], value: string) => {
  const productId = value.trim()
  return productId && !productIds.includes(productId) ? [...productIds, productId] : productIds
}

export const getProductSuggestionKeyword = (productIds: string[]) => productIds.join(',')

export const formatProductValues = (productValues: string) => {
  const values = productValues.split(',').filter(Boolean)
  const remainingCount = values.length - 5
  const remainingLabel = remainingCount > 0 ? ` +${remainingCount}` : ''

  return `${values.slice(0, 5).join(', ')}${remainingLabel}`
}

export const mergeProductSuggestions = (
  current: FilterOptionType[],
  incoming: FilterOptionType[],
) => {
  const values = new Set(current.map((item) => String(item.value)))
  return [...current, ...incoming.filter((item) => !values.has(String(item.value)))]
}

export const getProductSuggestionSelectionState = (
  selectedValues: string[],
  suggestions: FilterOptionType[],
) => {
  const loadedValues = suggestions.map((item) => String(item.value))
  const selectedCount = loadedValues.filter((value) => selectedValues.includes(value)).length

  return {
    checked: loadedValues.length > 0 && selectedCount === loadedValues.length,
    indeterminate: selectedCount > 0 && selectedCount < loadedValues.length,
  }
}

export const toggleLoadedProductSuggestions = (
  selectedValues: string[],
  suggestions: FilterOptionType[],
) => {
  const loadedValues = suggestions.map((item) => String(item.value))
  const allLoadedSelected =
    loadedValues.length > 0 && loadedValues.every((value) => selectedValues.includes(value))

  return allLoadedSelected ? [] : loadedValues
}
